import PropTypes from 'prop-types';
import React from 'react';
import icons from '@loggi/ui/components/utils/icons';
import * as colorSpec from './color-spec.scss';
const { getNotificationElement } = __NATIVE__
  ? require('./native')
  : require('./dom');

const colorsNotification = __NATIVE__ ? colorSpec : colorSpec.default;

const COLOR_STYLES = Object.keys(colorsNotification);
const SIZE_SMALL = 'small';
const SIZE_NORMAL = 'regular';
const SIZE_LARGE = 'large';
const SIZES = [SIZE_SMALL, SIZE_NORMAL, SIZE_LARGE];

function Notification(props) {
  const {
    inline,
    style,
    text,
    icon,
    size,
    displayIcon,
    align,
    buttonLabel,
    buttonLink
  } = props;

  const classes = [
    'notification',
    `notification-${style}`,
    { ['notification-inline']: inline },
    { [`notification-inline-${size}`]: inline },
    { [`notification-inline-with-button`]: inline && buttonLabel && buttonLink }
  ];

  const iconClasses = [`notification-inline-icon-${size}`];

  return getNotificationElement(
    inline,
    classes,
    displayIcon,
    iconClasses,
    icon,
    text,
    style,
    align,
    size,
    buttonLabel,
    buttonLink
  );
}

Notification.displayName = 'Notification';
Notification.propTypes = {
  inline: PropTypes.bool,
  style: PropTypes.oneOf(COLOR_STYLES),
  size: PropTypes.oneOf(SIZES),
  text: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(icons.names),
  displayIcon: PropTypes.bool,
  align: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
Notification.defaultProps = {
  inline: false,
  style: 'info',
  icon: icons.type.INFO,
  size: SIZE_SMALL,
  displayIcon: true,
  align: 'left',
  buttonLabel: null,
  buttonLink: null
};

export default Notification;
